/* eslint-disable */
import {
  Autocomplete,
  Button,
  Grid,
  MenuItem,
  TextField,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState, useContext } from "react";
import { getCacheData } from "../../services/CacheService";
import { getSistemaRoles } from "../../services/SistemaRolService";
import { getSistemaRolPermisos, saveSistemaRolPermisos } from "../../services/SistemaRolPermisoService";
import Message from "../../utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const nameItemsText = "Permisos por rol de sistema";
//
// #####################################################################################################################
//
const SistemaRolPermiso = () => {
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [sistemas, setSistemas] = useState([]);
  const [sistemaRoles, setSistemaRoles] = useState([]);
  const [sistemaRolPermisos, setSistemaRolPermisos] = useState([]);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [inputValueACSistemas, setInputValueACSistemas] = useState("");
  const [valueACSistemas, setValueACSistemas] = useState(null);
  const [inputValueACSistemaRoles, setInputValueACSistemaRoles] = useState("");
  const [valueACSistemaRoles, setValueACSistemaRoles] = useState(null);

  const { hasPermission } = useContext(AuthContext);
  const _crearSistemaRolPermiso = hasPermission("sistema-rol-permiso-c");

  const tableColumns = [
    {
      field: "descripcion_sistema_permiso",
      headerName: "Permiso",
      headerAlign: "center",
      align: "left",
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.descripcion_sistema_permiso;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "observaciones_sistema_permiso",
      headerName: "Observaciones",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.observaciones_sistema_permiso;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    loadSistemas();
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (valueACSistemas) {
      setInputValueACSistemaRoles("");
      setValueACSistemaRoles(null);
      setSistemaRolPermisos([]);
      loadSistemaRoles();
    }
  }, [valueACSistemas]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (valueACSistemaRoles) {
      loadSistemaRolPermisos();
    } else {
      setSistemaRolPermisos([]);
    }
  }, [valueACSistemaRoles]);
  //
  // ################################################################################
  //
  const loadSistemas = async () => {
    const response = await getCacheData("sistema");
    if (response.ok) {
      let _response = response.data.data;
      let _sistemas = [];
      _response.forEach((item) => {
        _sistemas.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setSistemas(_sistemas);
    } else {
      setSistemas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadSistemaRoles = async () => {
    const _params = {
      idSistema: valueACSistemas.id,
      estado: "habilitado",
    };
    const response = await getSistemaRoles(_params);

    if (response.ok) {
      let _response = response.data.data;
      let _sistemaRoles = [];

      _response.forEach((item) => {
        _sistemaRoles.push({
          id: item.id,
          label: item.descripcion,
        });
      });

      setSistemaRoles(_sistemaRoles);
    } else {
      setSistemaRoles([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadSistemaRolPermisos = async () => {
    let _params = {
      id_sistema: valueACSistemas.id,
      id_sistema_rol: valueACSistemaRoles.id,
    };

    setIsDoingSomething(true);
    const response = await getSistemaRolPermisos(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      const _sistemaRolPermisosList = response.data.data.sistema_rol_permiso_list;
      setSistemaRolPermisos(_sistemaRolPermisosList);
      setRowSelectionModel(
        _sistemaRolPermisosList
          .filter(row => row.efectivo)
          .map(row => row.id)
      );
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {

    const _sistemaRolPermisoList = sistemaRolPermisos
      .filter((sistemaRolPermiso) => sistemaRolPermiso.efectivo)
      .map((sistemaRolPermiso) => ({
        id_sistema_permiso: sistemaRolPermiso.id_sistema_permiso,
      }));

    const _sistemaRolPermisosObject = {
      id_sistema: valueACSistemas.id,
      id_sistema_rol: valueACSistemaRoles.id,
      sistema_rol_permiso_list: _sistemaRolPermisoList,
    };

    setIsDoingSomething(true);
    const response = await saveSistemaRolPermisos(_sistemaRolPermisosObject);
    setIsDoingSomething(false);

    if (response.ok) {
      setInputValueACSistemas("");
      setValueACSistemas(null);
      setInputValueACSistemaRoles("");
      setValueACSistemaRoles(null);
      setSistemaRoles([]);
      setSistemaRolPermisos([]);
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };  //
  // ################################################################################
  //
  const handleCancel = () => {
    setValueACSistemaRoles(null);
    setInputValueACSistemaRoles("");
    setSistemaRolPermisos([]);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Box sx={{ mx: 10, px: 1, pb: 1 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
              <Typography variant="h5" display="cristal" gutterBottom >
                {nameItemsText}
              </Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <Autocomplete
              id="sistema"
              size="small"
              value={valueACSistemas}
              onChange={(event, newValue) => {
                setValueACSistemas(newValue);
              }}
              inputValue={inputValueACSistemas}
              onInputChange={(event, newInputValue) => {
                setInputValueACSistemas(newInputValue);
              }}
              options={sistemas}
              renderInput={(params) => <TextField {...params} label="Sistema" />}
              isOptionEqualToValue={(option, value) => option.value === value.value}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={3}>
            <Autocomplete
              id="sistemaRoles"
              size="small"
              value={valueACSistemaRoles}
              onChange={(event, newValue) => {
                setValueACSistemaRoles(newValue);
              }}
              inputValue={inputValueACSistemaRoles}
              onInputChange={(event, newInputValue) => {
                setInputValueACSistemaRoles(newInputValue);
              }}
              options={sistemaRoles}
              renderInput={(params) => <TextField {...params} label="Roles del Sistema" />}
              isOptionEqualToValue={(option, value) => option.value === value.value}
            />
          </Grid>
        </Grid>

        <Box sx={{ mt: 2, width: '100%' }}>
          <DataGrid
            rows={sistemaRolPermisos}
            columns={tableColumns}
            disableVirtualization
            rowSelectionModel={rowSelectionModel}
            onRowSelectionModelChange={(newSelection) => {
              setRowSelectionModel(newSelection);
              setSistemaRolPermisos(prevPermisos =>
                prevPermisos.map(permiso => ({
                  ...permiso,
                  efectivo: newSelection.includes(permiso.id)
                }))
              );
            }}
            checkboxSelection
            {...tableOptions}
            hideFooter={false}
          />
        </Box>

        <Grid item xs={12}>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
          >

            {_crearSistemaRolPermiso && (
              <Button
                sx={{ mr: 1 }}
                variant="contained"
                size="small"
                onClick={handleSave}
                color="primary"
                startIcon={<SaveIcon />}
                disabled={sistemaRolPermisos.length === 0}
              >
                Guardar
              </Button>
            )}

            <Button
              variant="outlined"
              size="small"
              onClick={handleCancel}
            >
              Cancelar
            </Button>
          </Box>
        </Grid>
      </Box>

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default SistemaRolPermiso;
